export const getAbTestVariant = ({ abTestFeatureFlag, featureFlags }) => {
    if (!abTestFeatureFlag)
        return undefined;
    const abTestValue = featureFlags[abTestFeatureFlag.key] ?? '';
    return abTestFeatureFlag.abTestVariantValues[abTestValue.toString()];
};
